import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Field, FieldLabel, FieldSet, FieldLegend } from '@/components/ui/field';
export interface BirthDischargeConfiguration {
  maternal_items: { id: string; label: string }[];
  newborn_items: { id: string; label: string }[];
}
export function BirthDischargeConfigEditor({
  value,
  onChange,
}: {
  value?: BirthDischargeConfiguration;
  onChange: (value: BirthDischargeConfiguration) => void;
}) {
  const current = value ?? { maternal_items: [], newborn_items: [] };
  function update(kind: 'maternal_items' | 'newborn_items', items: { id: string; label: string }[]) {
    onChange({ ...current, [kind]: items });
  }
  return (
    <FieldSet>
      <FieldLegend>Birth discharge checklist</FieldLegend>
      <p className="text-sm text-muted-foreground">
        Define the practice-reviewed requirements for maternal and newborn discharge. Changing the checklist uses the
        newly published practice configuration version.
      </p>
      {(['maternal_items', 'newborn_items'] as const).map((kind) => (
        <FieldSet key={kind}>
          <FieldLegend>{kind === 'maternal_items' ? 'Maternal requirements' : 'Newborn requirements'}</FieldLegend>
          {current[kind].map((item, index) => (
            <div className="grid items-end gap-3 sm:grid-cols-[1fr_2fr_auto]" key={index}>
              <Field>
                <FieldLabel htmlFor={`${kind}-${index}-id`}>Stable identifier</FieldLabel>
                <Input
                  id={`${kind}-${index}-id`}
                  className="min-h-11"
                  value={item.id}
                  onChange={(e) =>
                    update(
                      kind,
                      current[kind].map((v, i) => (i === index ? { ...v, id: e.target.value } : v)),
                    )
                  }
                />
              </Field>
              <Field>
                <FieldLabel htmlFor={`${kind}-${index}-label`}>Requirement</FieldLabel>
                <Input
                  id={`${kind}-${index}-label`}
                  className="min-h-11"
                  value={item.label}
                  onChange={(e) =>
                    update(
                      kind,
                      current[kind].map((v, i) => (i === index ? { ...v, label: e.target.value } : v)),
                    )
                  }
                />
              </Field>
              <Button
                type="button"
                variant="outline"
                className="min-h-11"
                onClick={() =>
                  update(
                    kind,
                    current[kind].filter((_, i) => i !== index),
                  )
                }>
                Remove requirement
              </Button>
            </div>
          ))}
          <Button
            type="button"
            className="min-h-11 self-start"
            variant="outline"
            onClick={() => update(kind, [...current[kind], { id: '', label: '' }])}>
            Add {kind === 'maternal_items' ? 'maternal' : 'newborn'} requirement
          </Button>
        </FieldSet>
      ))}
    </FieldSet>
  );
}
